export default {
  sections: {
    address: 'Adresse',
    legal_address: "Adresse d'enregistrement",
    invoice_address: 'Adresse de facturation',
  },
  form: {
    display_name: {
      label: 'Nom convivial',
      placeholder: "Saisir le nom convivial de l'entreprise",
    },
    legal_name: {
      label: 'Raison sociale',
      placeholder: 'Saisir la raison sociale',
      tooltip: "Nom d'enregistrement. Affiché sur les rapports de versement, contrat, etc.",
    },
    timezone: {
      label: 'Fuseau horaire',
    },
    has_dedicated_invoice_address: {
      label: 'Infos de facturation différentes',
    },
  },
  buttons: {
    next: 'Suivant',
  },
};
